import * as Stimulus from "@hotwired/stimulus"

/**
 * Enables toggling of form fields. Assumes that the default state
 * of the form when the page loads is correct.
 **/
export class FormFieldToggleController extends Stimulus.Controller {
    static targets = [ 'toggleField', 'toggleOptionalField', 'toggleControl' ];

    connect() {
        this.toggleControlTargets.forEach(($el) => {
            this.runToggle($el);
        });
    }

    toggle(e) {
        this.runToggle(e.target);
    }

    runToggle($el) {
        var $selectedOpt = $el.children[$el.selectedIndex];
        var dependentFields = $selectedOpt.dataset['dependentFields'].split(' ');

        this.toggleFieldTargets.forEach(($target) => {
            if(dependentFields.indexOf($target.id) >= 0) {
                $target.closest('fieldset').classList.remove('hidden');
                $target.required = true;
                $target.disabled = false;
            } else {
                $target.closest('fieldset').classList.add('hidden');
                $target.required = false;
                $target.disabled = true;
            }

        });

        this.toggleOptionalFieldTargets.forEach(($target) => {
            if(dependentFields.indexOf($target.id) >= 0) {
                $target.closest('fieldset').classList.remove('hidden');
                $target.disabled = false;
            } else {
                $target.closest('fieldset').classList.add('hidden');
                $target.disabled = true; // Disabled must be set so that the value is explicitly not submitted
            }

        });
    }

}
